module.exports = __webpack_public_path__ + "assets/img/4-1-en.69c13c93.png";